import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Select } from 'core/form';

import AdminFilterSidebar from 'app/components/admin/AdminFilterSidebar';
import { DEFAULT_POLICY_TYPES, DEFAULT_LOOKBACK_SECONDS, ALERTING_TRENDS_SHORTCUTS } from './constants';

@inject('$alerting')
@withRouter
@observer
class AlertingTrendsSubscriptionFilters extends Component {
  static defaultProps = {
    filterValues: undefined
  };

  get resetValues() {
    return {
      applications: DEFAULT_POLICY_TYPES,
      lookbackSeconds: DEFAULT_LOOKBACK_SECONDS
    };
  }

  get filterFields() {
    const { $alerting, filterValues, readyOnly } = this.props;

    const filterOverrides = {};
    const passedFilters = Object.assign({}, filterValues, filterOverrides);

    const filterFields = {
      lookbackSeconds: {
        disabled: readyOnly,
        name: 'lookbackSeconds',
        label: 'Time Range',
        defaultValue: this.resetValues.lookbackSeconds,
        customField: <Select fill />,
        options: ALERTING_TRENDS_SHORTCUTS
      },

      applications: {
        disabled: readyOnly,
        name: 'applications',
        label: 'Type',
        defaultValue: this.resetValues.applications,
        allowMultiSelect: true,
        showCheckboxes: true,
        options: $alerting.policyTypeOptions
      }
    };

    if (passedFilters) {
      Object.keys(passedFilters).forEach((key) => {
        let defaultValue = passedFilters[key];
        const filterField = filterFields[key];

        // set the default form values for all of the incoming query values and prop values
        if (filterField) {
          if (filterField.allowMultiSelect && !Array.isArray(defaultValue)) {
            defaultValue = [defaultValue];
          }

          if (key === 'lookbackSeconds') {
            defaultValue = parseInt(defaultValue) || 0;
            // Make sure lookback is at least 24 hours
            if (defaultValue < 86400) {
              defaultValue = 86400;
            }
          }

          filterField.defaultValue = defaultValue;
        }
      });
    }

    return Object.values(filterFields);
  }

  get adjustedFilterValues() {
    const { filterValues } = this.props;

    if (!filterValues) {
      return filterValues;
    }

    const adjusted = { ...filterValues };

    // Remove startDate/endDate - subscriptions only use lookbackSeconds
    delete adjusted.startDate;
    delete adjusted.endDate;

    // Ensure we have a lookbackSeconds value (default to 90 days if missing)
    if (!adjusted.lookbackSeconds) {
      adjusted.lookbackSeconds = this.resetValues.lookbackSeconds;
    }

    // Make sure lookbackSeconds is at least 24 hours
    if (adjusted.lookbackSeconds < 86400) {
      adjusted.lookbackSeconds = 86400;
    }

    return adjusted;
  }

  handleFilterChange = (filters) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(filters);
    }
  };

  render() {
    const { filterValues, ...otherProps } = this.props;

    return (
      <AdminFilterSidebar
        {...otherProps}
        filterValues={this.adjustedFilterValues}
        filterFields={this.filterFields}
        resetValues={this.resetValues}
        onFilterChange={this.handleFilterChange}
      />
    );
  }
}

export default AlertingTrendsSubscriptionFilters;
